const es = {
  translation: {
    navigation: {
      invoices: 'facturas',
      advances: 'Adelantos',
      payments: 'Pagos',
      collections: 'Cobranazas',
      creditlines: 'Lineas de crédito',
    },
  },
}

export default es
